<div class="row page-header">
    <div class="col-12">
        <h1>HCSS API Test <small>Test connection to HCSS HeavyBid API</small></h1>
    </div>
</div>

<div>
    <div class="row">
        <div class="col-12">
            <div class="row mb-3">
                <div class="col-12">
                    <div class="btn-group" role="group">
                        <button class="btn btn-primary" (click)="testConnection()" [disabled]="isLoadingTestConnection">
                            @if (isLoadingTestConnection) {
                                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Testing...
                            } @else {
                                Test Connection
                            }
                        </button>
                        <button class="btn btn-secondary" (click)="getBusinessUnits()" [disabled]="isLoadingBusinessUnits">
                            @if (isLoadingBusinessUnits) {
                                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Loading...
                            } @else {
                                Get Business Units
                            }
                        </button>
                        <button class="btn btn-success" (click)="getBidsFromPast12Months()" [disabled]="isLoadingBids">
                            @if (isLoadingBids) {
                                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Loading...
                            } @else {
                                Get Bids
                            }
                        </button>
                        <button class="btn btn-warning" (click)="getActivities()" [disabled]="isLoadingActivities">
                            @if (isLoadingActivities) {
                                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Loading...
                            } @else {
                                Get Activities
                            }
                        </button>
                        <button
                            class="btn btn-outline-primary"
                            type="button"
                            (click)="syncDatabase()"
                            [disabled]="isLoadingSyncDatabase"
                        >
                            @if (isLoadingSyncDatabase) {
                                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Syncing...
                            } @else {
                                Sync API data to database
                            }
                        </button>
                        <button
                            class="btn btn-outline-dark"
                            type="button"
                            (click)="getActivitiesForCompareEstimate()"
                            [disabled]="isLoadingCompareEstimate"
                        >
                            @if (isLoadingCompareEstimate) {
                                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Loading...
                            } @else {
                                HCSS activities (API) for {{ compareEstimateCode }}
                            }
                        </button>
                    </div>
                </div>
            </div>

            <div class="row mb-3">
                <div class="col-12">
                    <div class="input-group" style="max-width: 500px">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Enter code pattern (e.g., 25154)"
                            [(ngModel)]="codePattern"
                            (keyup.enter)="getEstimatesByCodePattern()"
                        />
                        <button
                            class="btn btn-info"
                            type="button"
                            (click)="getEstimatesByCodePattern()"
                            [disabled]="isLoadingCodePattern"
                        >
                            @if (isLoadingCodePattern) {
                                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Searching...
                            } @else {
                                Search by Code Pattern
                            }
                        </button>
                    </div>
                    <small class="form-text text-muted">Search for estimates by code pattern (e.g., "25154" will find "25154", "25154MISC", "25154MISC1", etc.)</small>
                </div>
            </div>

            @if (errorMessage) {
                <div class="alert alert-danger" role="alert"><strong>Error:</strong> {{ errorMessage }}</div>
            }

            @if (compareEstimateActivities.length > 0) {
                <div class="row mb-3">
                    <div class="col-12">
                        <h4>Activities (API) for <code>{{ compareEstimateCode }}</code><small> (code prefix / add-ons)</small></h4>
                        <p class="text-muted small">
                            Server uses OData <code>startswith(estimateCode,'…')</code>. The date column is API
                            <code>lastModified</code> mapped to match the &quot;Date Created&quot; column layout used for the import grid.
                        </p>
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="estimateCompareGrid"></action-toolbar-count>
                                    <action-toolbar-search
                                        name="search-compare"
                                        [(ngModel)]="estimateCompareGrid.filter"
                                    ></action-toolbar-search>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="compareEstimateGrid"
                                    #compareEstimateGridEl
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="estimateCompareGrid.initialize(compareEstimateGridEl)"
                                    (destroy)="estimateCompareGrid.destroy()"
                                    [itemsSource]="estimateCompareGrid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column
                                        [header]="'Estimate Code'"
                                        [binding]="'estimateCode'"
                                        [width]="120"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Estimate Name'"
                                        [binding]="'estimateName'"
                                        [width]="300"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Activity Code'"
                                        [binding]="'activityCode'"
                                        [width]="120"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Activity Description'"
                                        [binding]="'activityDescription'"
                                        [width]="250"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Non-Add'"
                                        [binding]="'nonAdditive'"
                                        [width]="90"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Save Non-Add'"
                                        [binding]="'saveNonAdditive'"
                                        [width]="110"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Date Created'"
                                        [binding]="'dateCreated'"
                                        [width]="130"
                                        [format]="'d'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Man Hours'"
                                        [binding]="'manHours'"
                                        [width]="100"
                                        [format]="'N2'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Direct Total Cost'"
                                        [binding]="'directTotalCost'"
                                        [width]="150"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Labor Cost'"
                                        [binding]="'laborCost'"
                                        [width]="120"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Permanent Material Cost'"
                                        [binding]="'permanentMaterialCost'"
                                        [width]="180"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Construction Material Cost'"
                                        [binding]="'constructionMaterialCost'"
                                        [width]="200"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Equipment Cost'"
                                        [binding]="'equipmentCost'"
                                        [width]="130"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Subcontract Cost'"
                                        [binding]="'subcontractCost'"
                                        [width]="150"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                                <grid-selection-calculation [grid]="compareEstimateGridEl"></grid-selection-calculation>
                            </div>
                        </div>
                    </div>
                </div>
            }

            <!-- Test Connection Results -->
            @if (testConnectionResult) {
                <div class="row mb-3">
                    <div class="col-12">
                        <div class="alert alert-success" role="alert">
                            <strong>Connection Test Result:</strong>
                            <pre class="mt-2 mb-0" style="max-height: 300px; overflow-y: auto">{{ testConnectionResult }}</pre>
                        </div>
                    </div>
                </div>
            }

            <!-- Activities Results -->
            @if (activities.length > 0) {
                <div class="row mb-3">
                    <div class="col-12">
                        <h4>Activities ({{ activities.length }})</h4>
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="activitiesGrid"></action-toolbar-count>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="activitiesGrid"
                                    #activitiesGridElement
                                    appAutoSize
                                    (initialized)="activitiesGrid.initialize(activitiesGridElement)"
                                    (destroy)="activitiesGrid.destroy()"
                                    [itemsSource]="activitiesGrid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column [header]="'Estimate Code'" [binding]="'estimateCode'" [width]="120"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Activity Code'" [binding]="'activityCode'" [width]="120"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Description'" [binding]="'description'" [width]="'*'"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Non-Add'" [binding]="'nonAdditive'" [width]="90"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Save Non-Add'"
                                        [binding]="'saveNonAdditive'"
                                        [width]="110"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Last Modified'"
                                        [binding]="'lastModified'"
                                        [format]="'MM/dd/yyyy'"
                                        [width]="120"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'ManHours'"
                                        [binding]="'manHours'"
                                        [format]="'n2'"
                                        [width]="100"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'DirectTotalCost'"
                                        [binding]="'directTotalCost'"
                                        [format]="'c'"
                                        [width]="130"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'LaborCost'"
                                        [binding]="'laborCost'"
                                        [format]="'c'"
                                        [width]="110"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'SubcontractCost'"
                                        [binding]="'subcontractCost'"
                                        [format]="'c'"
                                        [width]="130"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'PermanentMaterialCost'"
                                        [binding]="'permanentMaterialCost'"
                                        [format]="'c'"
                                        [width]="160"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'EquipmentCost'"
                                        [binding]="'equipmentCost'"
                                        [format]="'c'"
                                        [width]="120"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'ConstructionMaterialCost'"
                                        [binding]="'constructionMaterialCost'"
                                        [format]="'c'"
                                        [width]="170"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                            </div>
                        </div>
                    </div>
                </div>
            }

            <!-- Business Units Results -->
            @if (businessUnits.length > 0) {
                <div class="row mb-3">
                    <div class="col-12">
                        <h4>Business Units ({{ businessUnits.length }})</h4>
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="businessUnitsGrid"></action-toolbar-count>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="businessUnitsGrid"
                                    #businessUnitsGridElement
                                    appAutoSize
                                    (initialized)="businessUnitsGrid.initialize(businessUnitsGridElement)"
                                    (destroy)="businessUnitsGrid.destroy()"
                                    [itemsSource]="businessUnitsGrid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column [header]="'ID'" [binding]="'id'" [width]="200"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="'*'"></wj-flex-grid-column>
                                </wj-flex-grid>
                            </div>
                        </div>
                    </div>
                </div>
            }

            <!-- Bids Results -->
            @if (bids.length > 0) {
                <div class="row">
                    <div class="col-12">
                        <h4>Estimates ({{ bids.length }})</h4>
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="grid"></action-toolbar-count>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="mainGrid"
                                    #mainGrid
                                    appAutoSize
                                    (initialized)="grid.initialize(mainGrid)"
                                    (destroy)="grid.destroy()"
                                    [itemsSource]="grid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column [header]="'Code'" [binding]="'estimateCode'" [width]="120"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="'*'"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Date Created'"
                                        [binding]="'createdDate'"
                                        [format]="'MM/dd/yyyy'"
                                        [width]="120"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Sum of Estimate Total Cost'"
                                        [binding]="'estimateTotalCost'"
                                        [format]="'c'"
                                        [width]="180"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Sum of Actual Bid Markup'"
                                        [binding]="'actualBidMarkup'"
                                        [format]="'c'"
                                        [width]="180"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Sum of Actual Markup Takeoff'"
                                        [binding]="'actualMarkupTakeoff'"
                                        [format]="'c'"
                                        [width]="200"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Sum of Addon Bond Total'"
                                        [binding]="'addonBondTotal'"
                                        [format]="'c'"
                                        [width]="180"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Sum of AddonCost'"
                                        [binding]="'addonCost'"
                                        [format]="'c'"
                                        [width]="150"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Sum of AddonMarkup'"
                                        [binding]="'addonMarkup'"
                                        [format]="'c'"
                                        [width]="160"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Bid Date'"
                                        [binding]="'bidDate'"
                                        [format]="'MM/dd/yyyy'"
                                        [width]="120"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Sum of BidTotal'"
                                        [binding]="'bidTotal'"
                                        [format]="'c'"
                                        [width]="150"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                            </div>
                        </div>
                    </div>
                </div>
            } @else if (
                !isLoading &&
                !errorMessage &&
                !testConnectionResult &&
                businessUnits.length === 0 &&
                activities.length === 0 &&
                compareEstimateActivities.length === 0
            ) {
                <div class="alert alert-info" role="alert">
                    Click one of the buttons above to test the HCSS API connection, retrieve business units, get bids, or
                    get activities.
                </div>
            }
        </div>
    </div>
</div>
